module.exports = __webpack_public_path__ + "img/goin1.080ebedb.jpg";